import { useQuery } from '@tanstack/react-query';

import { getOKRs } from '../api';

export const useOKRs = () =>
  useQuery({
    queryKey: ['okrs'],
    queryFn: getOKRs,
    staleTime: 1000 * 60 * 15,
  });
